export default __webpack_public_path__ + "static/media/photo--sm--wheel-4.1e3edae3.jpg";